import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { loginWithUser } = useAuth();
  const [error, setError] = useState(null);
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current) return; // guard against StrictMode double-invoke
    calledRef.current = true;
    const token = params.get("token");
    if (!token) {
      setError("Missing token.");
      return;
    }
    (async () => {
      try {
        const r = await api.post("/auth/verify", { token });
        // Session is now set via HttpOnly cookie by the server; body carries the user.
        loginWithUser(r.data.user);
        nav("/dashboard", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Invalid or expired link.");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-start px-8">
      <div className="max-w-lg">
        <div className="mono-caps mb-6">Signing you in</div>
        {error ? (
          <>
            <h1 className="font-display text-4xl mb-6">Sign-in failed</h1>
            <p className="text-slate-500 mb-8" data-testid="auth-error">{error}</p>
            <button className="btn-ghost" onClick={() => nav("/")} data-testid="auth-back-to-login">
              Back to login
            </button>
          </>
        ) : (
          <div className="text-slate-500 animate-pulse">Verifying token…</div>
        )}
      </div>
    </div>
  );
}
